// removed by extract-text-webpack-plugin
module.exports = {"base":"IndustrialResource_base--2RgJu","base__small":"IndustrialResource_base__small--3FBcG","baseSmall":"IndustrialResource_base__small--3FBcG","base__large":"IndustrialResource_base__large--nlBwh","baseLarge":"IndustrialResource_base__large--nlBwh","notEnough":"IndustrialResource_notEnough--14TyY"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/IndustrialResource/IndustrialResource.css
// module id = 1783
// module chunks = 16